import React, { Fragment } from 'react';
import { getEditorPreloader } from '@confluence-classic/confluence-fabric-editor/src/editorPreloader.tsx';
import { ClassicEditorContextProviderLoader } from '@confluence-classic/confluence-fabric-editor/src/components/ClassicEditorContextProvider/index.js';

import { EditContentButtonPreloaderContext } from '@confluence/edit-button/entry-points/EditContentButtonPreloaderContext.ts';
import { EmbeddedViewPageLoader } from '@confluence/embedded-confluence/entry-points/EmbeddedViewPage.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary.ts';
import { ViewPageLoader } from '@confluence/view-page/entry-points/ViewPage.ts';
import { PageShownPublicLinksEventLoader } from '@confluence/external-share-utils/entry-points/PageShownPublicLinksEventLoader.tsx';
import { PresenterModeContextProvider } from '@confluence/presentation-mode';

import SendTrackViewPageEvent from '../../SendTrackViewPageEvent/index.js';
import { ContentExtensionsProvider } from '../../ContentExtensionsProvider/index.ts';
import SpaceBase from '../../SpaceBase/index.js';
import {
	LazyDwellTime,
	LazyMobileWebContainer,
	LazyConsumptionViewedAndCompletedEventTracker,
} from '../lazyComponents.js';
import { CommentContextWrapper } from '../commentContextWrapper.tsx';
/**
 * This component handles page, blog and space overview routes
 */
export const ViewPageRouteComponent = ({
	spaceKey,
	contentId,
	isPage,
	isMobile,
	isEmbeddedConfluence,
}: {
	spaceKey: any;
	contentId: any;
	isPage: any;
	isMobile: any;
	isEmbeddedConfluence: any;
}): React.JSX.Element => {
	const pageType = isPage ? 'page' : 'blogpost';

	let component;
	if (isEmbeddedConfluence) {
		component = (
			<CommentContextWrapper>
				<EmbeddedViewPageLoader
					contentId={contentId}
					spaceKey={spaceKey}
					ClassicEditorContextProviderLoader={ClassicEditorContextProviderLoader}
				/>
			</CommentContextWrapper>
		);
	} else if (isMobile) {
		component = (
			<CommentContextWrapper>
				<LazyMobileWebContainer />
			</CommentContextWrapper>
		);
	} else {
		component = (
			<CommentContextWrapper>
				{/* oxlint-disable-next-line react/jsx-no-constructed-context-values */}
				<EditContentButtonPreloaderContext.Provider value={getEditorPreloader()}>
					<PresenterModeContextProvider contentId={contentId} spaceKey={spaceKey}>
						<ViewPageLoader
							spaceKey={spaceKey}
							contentId={contentId}
							ClassicEditorContextProviderLoader={ClassicEditorContextProviderLoader}
						>
							<ErrorBoundary attribution={Attribution.BACKBONE}>
								<SendTrackViewPageEvent pageType={pageType} />
							</ErrorBoundary>
						</ViewPageLoader>
					</PresenterModeContextProvider>
				</EditContentButtonPreloaderContext.Provider>
			</CommentContextWrapper>
		);
	}

	return (
		<Fragment>
			<SpaceBase>
				<ContentExtensionsProvider>{component}</ContentExtensionsProvider>
			</SpaceBase>
			<LazyDwellTime />
			<LazyConsumptionViewedAndCompletedEventTracker
				spaceKey={spaceKey}
				source="ViewPageRouteComponent"
				skip={isMobile}
			/>
			<PageShownPublicLinksEventLoader contentId={contentId} isPage={isPage} />
		</Fragment>
	);
};
